export default __webpack_public_path__ + "static/media/EditUserProfilePlus.37dafbec.svg";